module.exports = __webpack_public_path__ + "ae14bd2710d2f8112fc726dfddd507ff.svg";